import { Component, OnInit } from '@angular/core';
import {OcDamagesDataService} from '../../../../services/oc-damages-data.service';

@Component({
  selector: 'app-customer-damage-data',
  templateUrl: './customer-damage-data.component.html',
  styleUrls: ['./customer-damage-data.component.scss']
})
export class CustomerDamageDataComponent implements OnInit {

  private readonly API_ERROR_MESSAGE = 'CUSTOMER_DAMAGE_DATA.apiErrorMessage';

  get last2YearsOcDamages(): string {
    return this.ocDamagesDataService.last2YearsOcDamages ? this.ocDamagesDataService.last2YearsOcDamages : this.API_ERROR_MESSAGE;
  }

  get last5YearsOcDamages(): string {
    return this.ocDamagesDataService.last5YearsOcDamages ? this.ocDamagesDataService.last5YearsOcDamages : this.API_ERROR_MESSAGE;
  }

  constructor(private ocDamagesDataService: OcDamagesDataService) { }

  ngOnInit() {
  }

}
